import React, { Fragment } from 'react';
import {
  V2BlockIcon,
  V2CloseIcon,
  V2CreditcardIcon,
  V2DataprivacyIcon,
  V2FlagIcon,
  V2OverflowIcon,
  V2PaymentshubIcon,
  V2PendingPausedIcon,
  V2QuestionIcon,
  V2RefundIcon,
  V2SearchIcon,
  V2SecurityPatternIcon,
  V2TransferIcon,
} from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import { intents } from '../../common/constants';
import { PayPalCreditIcon } from '../../common/svgImages';

function TopicIntentIcons(props) {
  const { refId, size, className, dataTestId } = props;

  const renderTopicIntentIcon = () => {
    switch (refId) {
      case intents.SEARCH:
        return <V2SearchIcon size={size} className={className} data-testid={dataTestId} />;
      case intents.PAYMENTHOLD:
        return <V2PendingPausedIcon size={size} className={className} data-testid={dataTestId} />;
      case intents.FILE_DISPUTE:
        return <V2FlagIcon size={size} className={className} data-testid={dataTestId} />;
      case intents.DISPUTE_STATUS:
        return <V2QuestionIcon size={size} className={className} data-testid={dataTestId} />;
      case intents.REFUND:
        return <V2RefundIcon size={size} className={className} data-testid={dataTestId} />;
      case intents.LIMITATION:
        return <V2DataprivacyIcon size={size} className={className} data-testid={dataTestId} />;
      case intents.TRANSFER:
        return <V2TransferIcon size={size} className={className} data-testid={dataTestId} />;
      case intents.UNAUTHORIZED_TRANSACTION:
        return <V2SecurityPatternIcon size={size} className={className} data-testid={dataTestId} />;
      case intents.PAYMENT_DECLINE:
        return <V2CloseIcon size={size} className={className} data-testid={dataTestId} />;
      case intents.PAY_IN_4:
      case intents.PAY_IN_3:
        return <V2PaymentshubIcon size={size} className={className} data-testid={dataTestId} />;
      case intents.PAYPAY_CREDIT:
        return (
          <span className={`${className} sh_topic_intent__blob_icon_credit`} data-testid={dataTestId}>
            {PayPalCreditIcon}
          </span>
        );
      case intents.PAYMENT_DECLINE_OCP:
        return <V2BlockIcon size={size} className={className} data-testid={dataTestId} />;
      case intents.ADD_CARD:
        return <V2CreditcardIcon size={size} className={className} data-testid={dataTestId} />;
      case intents.OVERFLOW:
        return <V2OverflowIcon size={size} className={className} data-testid={dataTestId} />;
      default:
        return <V2FlagIcon size={size} className={className} data-testid={dataTestId} />;
    }
  };

  return <Fragment>{renderTopicIntentIcon()}</Fragment>;
}

TopicIntentIcons.propTypes = {
  size: PropTypes.string,
  className: PropTypes.string,
  refId: PropTypes.string,
  dataTestId: PropTypes.string,
};

export default TopicIntentIcons;
